// extracted by mini-css-extract-plugin
module.exports = {"row":"EJ1EGV3pozj65J928KtWKg==","nameColumn":"ZJH6KZnuFWnkzElrhi65bg==","iconWrapper":"nUmxPSuNM4DdmXC+S8JHbA==","imageWrapper":"xX4S5dAAXuXAcwmJwLGbtg=="};